function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLegalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 15.75c0-.758.063-.409-3.987-8.508a2.252 2.252 0 0 0-4.025 0C-.1 15.41 0 15.015 0 15.75c0 2.071 2.686 3.75 6 3.75s6-1.679 6-3.75zm-8.1-3.322c.534-1.062 1.22-2.423 2.084-4.177H6c.929 1.858 1.642 3.272 2.189 4.358.529 1.049.923 1.834 1.2 2.394H2.617c.291-.594.714-1.439 1.285-2.572zm20.85 9.322h-8.625V7.309a3.741 3.741 0 0 0 2.55-2.809h6.075a.75.75 0 0 0 .75-.75V3a.75.75 0 0 0-.75-.75h-6.316a3.745 3.745 0 0 0-6.867 0H5.25A.75.75 0 0 0 4.5 3v.75a.75.75 0 0 0 .75.75h6.075a3.741 3.741 0 0 0 2.55 2.809V21.75H5.25a.75.75 0 0 0-.75.75v.75a.75.75 0 0 0 .75.75h19.5a.75.75 0 0 0 .75-.75v-.75a.75.75 0 0 0-.75-.75zM15 5.25a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5zm15 10.5c0-.758.063-.409-3.987-8.508a2.252 2.252 0 0 0-4.025 0C17.9 15.41 18 15.015 18 15.75c0 2.071 2.686 3.75 6 3.75s6-1.679 6-3.75zM20.617 15c.29-.594.714-1.439 1.284-2.572.534-1.062 1.22-2.423 2.084-4.177H24c.929 1.858 1.642 3.272 2.189 4.358.529 1.049.923 1.834 1.2 2.394z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalIcon);
export default __webpack_public_path__ + "static/media/legal-icon.a084b7e7.svg";
export { ForwardRef as ReactComponent };